export default "__VITE_ASSET__TRTQWy19KwNZaJkwa1gJLQ__"